var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Cached, CacheKey } from '@ngx-cache/core';
import { HttpClient } from '@angular/common/http';
import { CacheConstants } from '../../shared/cache-constants';
import { Environment } from '../../shared/environment/environment';
import { Observable } from 'rxjs';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
var SofyService = /** @class */ (function () {
    function SofyService(httpClient) {
        this.httpClient = httpClient;
    }
    SofyService.prototype.getSalesOffer = function (omapiId, dtvIdentifier, customerProductHolding, promotions, address) {
        var product = {
            identifier: dtvIdentifier,
            address: address,
            installationaddress: address,
            omapiid: omapiId
        };
        var shoppingBasket = {
            products: [product],
            customerproductholding: customerProductHolding.customerproductholding,
            promotions: promotions.promotions
        };
        if (OmapiIdsUtils.salesOfferDate) {
            shoppingBasket.salesofferdate = OmapiIdsUtils.salesOfferDate;
        }
        return this.httpClient.post(this.sofyBaseUrl(), shoppingBasket);
    };
    SofyService.prototype.sofyBaseUrl = function () {
        return Environment.environmentConfig().sofyApiUrl;
    };
    __decorate([
        Cached(CacheConstants.SALES_OFFER),
        __param(0, CacheKey), __param(1, CacheKey), __param(2, CacheKey),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, Object, Object, Object]),
        __metadata("design:returntype", Observable)
    ], SofyService.prototype, "getSalesOffer", null);
    return SofyService;
}());
export { SofyService };
